import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'common-info-box',
  templateUrl: './info-box.component.html',
  styleUrls: ['./info-box.component.scss'],
})
export class InfoBoxComponent {
  @Input() text: string;
  @Input() maxWidth: string;
}
